export default function Projects() {

  const projectList = [
    {
      name: 'Stoistrom',
      description: 'Self-improvement app developed with ReactNative.',
      technologies: 'ReactNative, React',
      link: 'https://stoistrom.vercel.app',
      code: 'https://github.com/PureZinc/stoistrom-intro'
    },
    {
      name: 'Graphematics',
      description: 'Study Graph Theory easily! UI canvas for building your own graph!',
      technologies: 'React, JS Canvas',
      link: 'https://graphematics.vercel.app/',
      code: 'https://github.com/PureZinc/graphematics-frontend-typescript'
    },        
    {
      name: 'Plutona Cafe',
      description: 'A sci-fi themed cafe built using React.',
      technologies: 'React',
      link: 'https://plutona-cafe.vercel.app/',
      code: 'https://github.com/PureZinc/plutona-cafe-react'
    }
  ]

  return (
    <div className="portfolio-container">
      <div className="projects">
        <h1>My Projects</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 my-8 mx-6">
          {projectList.map((project, index) => (
            <div key={index} className="bg-blue-800 rounded-lg p-6 border-4 border-blue-950">
              <h2 className="text-xl mb-4 black-ops-font underline">{project.name}</h2>
              <p className="text-lg mb-4">{project.description}</p>
              <p className="text-sm mb-4">Technologies: {project.technologies}</p>
              <a href={project.link} target="_blank" rel="noreferrer" className="text-white hover:underline">View Project </a>
              |
              <a href={project.code} target="_blank" rel="noreferrer" className="text-white hover:underline"><span></span> View Code</a>
            </div>
          ))}
        </div>

      </div>
    </div>
  )
}
